export const filterNumericInput = (input: string, allowDecimals: boolean): string => {
    if (allowDecimals) {
        return input.replace(/[^\d.,-]/g, '');
    }
    return input.replace(/[^\d-]/g, '');
};

export const parseNumber = (input: string): number | null => {
    if (!input || input === '-') return null;

    const normalized = input.replace(',', '.');

    if (normalized === '.' || normalized === '-') return null;

    const num = parseFloat(normalized);
    return Number.isNaN(num) ? null : num;
};

export const formatNumber = (value: number | null | undefined): string => {
    if (value === null || value === undefined) return '';
    return String(value);
};
